import React from 'react';

import {
    useShareStore,
} from '../hooks/store';
import {
    useBasePath,
    useMediaConfig,
    useDictionary,
    useLang,
} from '../hooks/config';

import {
    ApolloLib,
    Fragments,
} from 'bdvp-graphql';

import Component from '../components/ShareModal';

const { useApolloClient } = ApolloLib;
const { MEDIA_PLAYBACK_SHARE } = Fragments;

const ShareModal = () => {

    const basePath = useBasePath();
    const dictionary = useDictionary();
    const config = useMediaConfig();
    const lang = useLang();
    const { shareMediaId } = useShareStore();
    const client = useApolloClient();

    const mediaPlayback = client.readFragment({
        id: `MediaPlayback:${shareMediaId}`,
        fragment: MEDIA_PLAYBACK_SHARE,
    });

    return (
        <Component
            basePath={basePath}
            mediaPlayback={mediaPlayback}
            config={config}
            dictionary={dictionary}
            lang={lang}
        />
    );

};

export default ShareModal;
